import React, { memo } from 'react'

import { useUnit } from 'effector-react'

import { useCallback, useMediaQueries } from 'hooks'

import Button from 'components/_old/Button/Button.jsx'

import { Paper } from 'components/atoms/Paper'
import { SelfValidatingForm } from 'components/atoms/SelfValidatingForm/SelfValidatingForm'

import { submitForm, $shouldShowProvidersBlock, $isFormSubmitting } from '../index'

import {
  AgreedCheckbox,
  AvailableToTransferFrom,
  CurrentDate,
  Declaration,
  Disclaimer,
  Headline,
  PensionDetails,
  RequestForm,
  TransferConditions,
} from './index'

const FORM_ID = 'sipp-transfer-form'

const Submit = memo((): React.ReactElement => {
  const isFormSubmitting = useUnit($isFormSubmitting)

  return (
    <Button type="submit" form={FORM_ID} mods={{ size: 'big block' }} disabled={isFormSubmitting}>
      {isFormSubmitting ? 'Submitting...' : 'Submit'}
    </Button>
  )
})
Submit.displayName = 'Submit'

type FormProps = {
  titleRef?: React.MutableRefObject<HTMLElement | undefined>
}

const Form = ({ titleRef }: FormProps): React.ReactElement => {
  const { desktop } = useMediaQueries()
  const shouldShowProvidersBlock = useUnit($shouldShowProvidersBlock)

  const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    submitForm()
  }, [])

  return (
    <SelfValidatingForm id={FORM_ID} onSubmit={handleSubmit}>
      <Headline ref={titleRef} />
      {shouldShowProvidersBlock && (
        <Paper top={desktop ? 40 : 48}>
          <AvailableToTransferFrom />
        </Paper>
      )}
      <Paper top={desktop ? 40 : 48}>
        <TransferConditions />
      </Paper>
      <Paper top={desktop ? 56 : 48}>
        <PensionDetails />
      </Paper>
      <Paper top={desktop ? 56 : 48}>
        <RequestForm />
      </Paper>
      <Paper top={desktop ? 56 : 48} data-test-id="declarationContent">
        <Declaration />
      </Paper>
      <Paper top={desktop ? 56 : 48} data-test-id="disclaimerContent">
        <Disclaimer />
      </Paper>
      <Paper top={desktop ? 56 : 48}>
        <CurrentDate />
        <Paper top={desktop ? 56 : 24}>
          <AgreedCheckbox />
        </Paper>
      </Paper>
    </SelfValidatingForm>
  )
}

export { Form, Submit }
